export default __webpack_public_path__ + "./images/tj.2715bcf1.png";